import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';

export default class FilterMenu extends Component {
  prepareFilters = () => this.props.filters.map(filter => Object.assign({}, filter, { label: `${filter.name} (${filter.count})` }));

  render() {
    const { selectedFilter, filterChangeHandler, isLoading } = this.props;
    const filters = this.prepareFilters();

    return (
      <>
        <ul className="m-0 show-for-large" style={{ listStyleType: 'none' }}>
          {filters.map(filter => (
            <li key={filter.name}>
              <div
                role="link"
                tabIndex={0}
                className="row m-0 cursor-pointer"
                onClick={() => (isLoading ? null : filterChangeHandler(filter))}
              >
                <div className={`small-9 columns pt-xxs pb-xxs ${selectedFilter === filter.name ? 'bg-quicksilver-50' : ''}`}>
                  {filter.name}
                </div>
                <div className={`columns pt-xxs pb-xxs ${selectedFilter === filter.name ? 'bg-quicksilver-50' : ''}`}>
                  {filter.isLoading ? <div className="loading-spinner-m" /> : filter.count}
                </div>
              </div>
            </li>
          ))}
        </ul>
        <Select
          onChange={filterChangeHandler}
          valueKey="name"
          labelKey="label"
          value={selectedFilter}
          options={filters}
          className="hide-for-large mb-base"
          clearable={false}
          searchable={false}
          isLoading={isLoading}
        />
      </>
    );
  }
}

FilterMenu.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape(
    {
      name: PropTypes.string,
      count: PropTypes.number,
    },
  )),
  selectedFilter: PropTypes.string,
  filterChangeHandler: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

FilterMenu.defaultProps = {
  filters: [
    {
      name: 'All',
      count: 0,
      active: true,
    },
  ],
  selectedFilter: 'All',
  isLoading: false,
};
